import { render, staticRenderFns } from "./commonFooter.vue?vue&type=template&id=ac541b26&scoped=true"
import script from "./commonFooter.vue?vue&type=script&lang=js"
export * from "./commonFooter.vue?vue&type=script&lang=js"
import style0 from "./commonFooter.vue?vue&type=style&index=0&id=ac541b26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac541b26",
  null
  
)

export default component.exports